import React from 'react';
import { Link } from 'react-router-dom';
import { ACADEMY_LINES } from '../../data/academyCourses';
import { useAcademy } from '../../context/Academy';
import { courseProgress } from '../../utils/academyProgress';
import type { Course } from '../../types/academy';
import { ProgressBar } from './ProgressBar';
interface CourseCardProps {
  course: Course;
}
export function CourseCard({
  course
}: CourseCardProps) {
  const {
    state,
    isEnrolled
  } = useAcademy();
  const enrolled = isEnrolled(course.slug);
  const progress = courseProgress(course, state);
  const line = ACADEMY_LINES.find(l => l.id === course.serviceLine)?.name;
  return <article className="group relative flex h-full flex-col rounded-md border border-line bg-panel p-6 transition-colors duration-200 hover:border-gold/70" data-id="element-430" data-mp="jzdjcja3evdr">
      <div className="flex items-center justify-between gap-3 text-small" data-id="element-431" data-mp="34rp46ri1gomk">
        <span className="font-medium text-gold" data-id="element-432" data-mp="2zs2p0cingyb4">Cavalla {line}</span>
        <span className="text-muted" data-id="element-433" data-mp="2zqrlmdt49skj">{course.difficulty}</span>
      </div>
      <h3 className="mt-4 font-display text-[19px] leading-snug text-ink" data-id="element-434" data-mp="2y792jx7dafuf">
        <Link to={`/academy/courses/${course.slug}`} className="after:absolute after:inset-0 after:rounded-md focus-visible:outline-none focus-visible:after:ring-2 focus-visible:after:ring-gold" data-id="element-435" data-mp="328b1ecxdgpvv">
          {course.title}
        </Link>
      </h3>
      <p className="mt-3 line-clamp-3 text-[14px] leading-relaxed text-body" data-id="element-436" data-mp="2ei8dm90hq632">{course.description}</p>
      <div className="mt-auto pt-6" data-id="element-437" data-mp="2j8x3jjwiuv03">
        {enrolled ? <div data-id="element-438" data-mp="2jahxb7b0i9ww">
            <div className="mb-2 flex justify-between text-small" data-id="element-439" data-mp="2jb1h6tk838dk">
              <span className="text-body" data-id="element-440" data-mp="25itnjao8jxj3">{progress.complete ? 'Completed' : 'In progress'}</span>
              <span className="text-ink" data-id="element-441" data-mp="2aheq3gqymtap">{progress.percent}%</span>
            </div>
            <ProgressBar percent={progress.percent} complete={progress.complete} label={`${course.title} progress`} data-id="element-442" data-mp="1vj2tfa3l7kjj" />
          </div> : <p className="text-small text-muted" data-id="element-443" data-mp="20kjqsvmv4ovd">
            {course.modules.length} modules · {course.hours} hours · Free
          </p>}
      </div>
    </article>;
}